import { Divider, ModalBody, ModalContent, useDisclosure } from '@nextui-org/react'
import { BaseModal, BaseModalHeader } from '../common/Modal'
import { ModalText } from '../common/Text'
import { SelectGroup } from './SelectGroup'
import { SelectButton } from './SelectButton'
import { SelectTanks } from './SelectTanks'
import { SelectTanksBrowserOpen } from './SelectTanksBrowserOpen'

export const SelectTanksToBrowse = () => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  return (
    <>
      <SelectTanksBrowserOpen onOpen={onOpen} />
      <BaseModal isOpen={isOpen} onOpenChange={onOpenChange} size={'5xl'}>
        <ModalContent>
          {(onClose) => (
            <>
              <BaseModalHeader
                title="Select Tanks to Browse"
                description={ModalText('Select Tanks to Browse')}
                data-testid="select-tanks-modal-header"
              />
              <ModalBody className="select-tanks-modal-body gap-0 min-h-[20rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden">
                <Divider className="my-4" style={{ margin: '1px' }} />
                <SelectGroup />
                <SelectTanks />
              </ModalBody>
              <SelectButton onClose={onClose} />
            </>
          )}
        </ModalContent>
      </BaseModal>
    </>
  )
}
